// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"db919789","148":"ce3286bf","205":"f0a8b944","770":"29abc363"}[chunkId] + ".chunk.js";
};